export const getInitials = (name: string): string => {
  const nameParts = name.split(' ');
  let initials = '';

  if (nameParts.length === 0) {
    return initials;
  }

  if (nameParts.length === 1) {
    initials = nameParts[0].substring(0, 2);
  } else {
    initials = `${nameParts[0].substring(0, 1)}${nameParts[nameParts.length - 1].substring(0, 1)}`;
  }

  return initials.toUpperCase();
};
